import { Select } from '@any-ui-react/core';
import { useMemo } from 'react';

import { type PerformanceReviewPeriodValue, periodLabel, toPeriodKey } from './period';

interface PeriodSelectProps {
  /** The periods to offer, newest first. Each page decides which periods exist (the tabulation setting page, for one, lists only periods that already have settings). */
  periods: readonly PerformanceReviewPeriodValue[];
  value: PerformanceReviewPeriodValue | null;
  disabled?: boolean;
  onChange: (period: PerformanceReviewPeriodValue) => void;
}

export const PeriodSelect = ({ periods, value, disabled = false, onChange }: PeriodSelectProps) => {
  const data = useMemo(
    () => periods.map(period => ({ value: toPeriodKey(period), label: periodLabel(period) })),
    [periods],
  );

  return (
    <Select
      allowDeselect={false}
      aria-label="Period"
      className="w-[140px]"
      classNames={{ option: 'tabular-nums' }}
      data={data}
      disabled={disabled}
      value={value ? toPeriodKey(value) : null}
      onChange={key => {
        const next = periods.find(period => toPeriodKey(period) === key);
        if (next) onChange(next);
      }}
    />
  );
};
